import React, {useState, useEffect} from 'react'
import {Header, Titulo} from '../elementos/Header'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import withRouter from './withRouter'
import Api from '../servicios/api'
import BtnRegresar from '../elementos/BtnRegresar'
import FormularioObjeto from './FormularioObjeto'
import Cargando from '../elementos/Cargando'
import favicon from '../imagenes/logoutm.png'

const EditarObjeto = (props) => {
    const [datosCargados, setdatosCargados] = useState(false);
    const [objeto, setObjeto] = useState([]);

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        fetch(Api+"?consultarObjetoID="+props.params.id)
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            setdatosCargados(true);
            setObjeto(datosRespuesta[0]);
        })
        .catch(console.log)
    }, [props]);

    if(!datosCargados){
        return(
            <Cargando />
        );
    }
    else{
        return (
            <>
                <HelmetProvider>
                <div>
                    <Helmet>
                        <link rel="shortcut icon" href={favicon} type="image/x-con"/>
                        <title>Actualizar Objeto</title>
                    </Helmet>
                </div>
            </HelmetProvider>

            <Header>
                    <Titulo>Actualizar Objeto</Titulo>
                    <BtnRegresar ruta="/objetos"/>
            </Header>

            <FormularioObjeto  objeto={objeto}/>
            </>
        );
    }
}
 
export default withRouter(EditarObjeto);